class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener(
      'input',
      this.debouncedOnSubmit.bind(this)
    );
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach(section => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(
          filterDataUrl,
          event
        )
        : FacetFiltersForm.renderSectionFromFetch(url, event);

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url }
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML =
      new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');
    const container = document.getElementById('ProductCount');

    if (container) {
      container.innerHTML = count ? count.innerHTML : '';
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );
    const matchesIndex = element => {
      const jsFilter = event
        ? event.target.closest('.js-filter')
        : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      element => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(
      matchesIndex
    );

    facetsToRender.forEach(element => {
      const elementToUpdate = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      elementToUpdate.innerHTML = element.innerHTML;
      if (elementToUpdate.tagName === 'DROPDOWN-INPUT')
        elementToUpdate.init();
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelector = '.js-facets-active';
    const activeFacetsElement = html.querySelector(
      activeFacetElementSelector
    );

    if (!activeFacetsElement) return;
    document.querySelector(activeFacetElementSelector).outerHTML =
      activeFacetsElement.outerHTML;
  }

  static renderCounts(source, target) {
    const selector = '.js-facets-selected';
    const targetElement = target.querySelector(selector);
    const sourceElement = source.querySelector(selector);

    if (sourceElement && targetElement) {
      target.querySelector(selector).outerHTML =
        source.querySelector(selector).outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)
      }`
    );
  }

  static getSections() {
    return [
      {
        section: document.querySelector('facet-filters-form').dataset
          .sectionId
      }
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const context = event.target.id.includes('desktop')
      ? 'mobile'
      : 'desktop';
    const formData = new FormData();
    const formDataElements = Array.from(
      event.target.closest('form').elements
    ).filter(
      element =>
        !element.id.includes(context) || element.name === 'sort_by'
    );
    for (const element of formDataElements) {
      if (!element.name) continue;
      if (element.type === 'checkbox') {
        if (element.checked) {
          formData.append(element.name, element.value);
        }
      } else {
        formData.append(element.name, element.value);
      }
    }
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf('?') + 1
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');
    this.fromSlider = this.querySelectorAll("input[type='range']")[0];
    this.toSlider = this.querySelectorAll("input[type='range']")[1];
    this.fromInput = this.querySelectorAll("input[type='number']")[0];
    this.toInput = this.querySelectorAll("input[type='number']")[1];
    this.mobileLabelFrom = this.querySelector(".range--slider-label-from-value");
    this.mobileLabelTo = this.querySelector(".range--slider-label-to-value");
    this.resetButton = this.querySelector("input[type='button'].range--reset");
    this.rangeMin = this.toInput.min;
    this.rangeMax = this.toInput.max;
    this.rangeDistance = this.rangeMax - this.rangeMin;
    this.sliderColor = this.dataset.sliderColor || "#b1b1b1";
    this.rangeColor = this.dataset.rangeColor || "#989898";
    this.setSlider(this.fromSlider.value, this.toSlider.value);


    this.setMinAndMaxValues();
  }

  addListeners() {
    this.fromSlider.addEventListener("input", this.updateFromSlider.bind(this)),
      this.toSlider.addEventListener("input", this.updateToSlider.bind(this)),
      this.fromInput.addEventListener("input", this.updateFromInput.bind(this)),
      this.fromInput.addEventListener("keypress", this.validateNumberInput),
      this.toInput.addEventListener("input", this.updateToInput.bind(this)),
      this.toInput.addEventListener("keypress", this.validateNumberInput),
      this.resetButton.addEventListener("click", this.handleResetButtonClick.bind(this));
  }
  validateNumberInput(t) {
    8 === t.charCode || (t.charCode >= 48 && t.charCode <= 57) || t.preventDefault();
  }
  connectedCallback() {
    this.addListeners();
  }
  updateFromInput(t) {
    const [e, i] = this.getParsed(this.fromInput, this.toInput),
      n = null !== e ? e : Number(this.fromInput.min),
      r = i || Number(this.toInput.max);

    n < this.fromInput.min
      ? (this.fromInput.value = Number(this.fromInput.min))
      : n > r && (this.fromInput.value = r),
      this.fromInput.value
        ? this.fromInput.value <= r
          ? (this.setSlider(this.fromInput.value, !1),
            (this.mobileLabelFrom.innerHTML = this.fromInput.value),
            this.showResetButton())
          : t.stopPropagation()
        : (this.setSlider(n, !1), (this.mobileLabelFrom.innerHTML = n));
  }
  updateToInput(t) {
    const [e, i] = this.getParsed(this.fromInput, this.toInput),
      n = null !== i ? i : Number(this.toInput.max),
      r = e || Number(this.fromInput.min);
    n > this.toInput.max && (this.toInput.value = Number(this.toInput.max)),
      this.toInput.value
        ? r <= this.toInput.value
          ? (this.setSlider(!1, this.toInput.value),
            (this.mobileLabelTo.innerHTML = this.toInput.value),
            this.showResetButton())
          : t.stopPropagation()
        : (this.setSlider(!1, n), (this.mobileLabelTo.innerHTML = n));
  }
  updateFromSlider() {
    const [t, e] = this.getParsed(this.fromSlider, this.toSlider);

    t > e ? ((this.fromSlider.value = e), (this.fromInput.value = e)) : (this.fromInput.value = t),
      this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 }));
  }
  updateToSlider() {
    const [t, e] = this.getParsed(this.fromSlider, this.toSlider);
    t <= e ? (this.toInput.value = e) : ((this.toInput.value = t), (this.toSlider.value = t)),
      this.toInput.dispatchEvent(new Event("input", { bubbles: !0 }));
  }
  getParsed(t, e) {
    return [t.value ? parseInt(t.value, 10) : null, e.value ? parseInt(e.value, 10) : null];
  }
  setSlider(t, e) {
    !1 !== t && (this.fromSlider.value = t), !1 !== e && (this.toSlider.value = e);
    const i = this.fromSlider.value - this.rangeMin,
      n = this.toSlider.value - this.rangeMin,
      r = (i / this.rangeDistance) * 100,
      s = (n / this.rangeDistance) * 100,
      o = 8 - 0.15 * r,
      a = 8 - 0.15 * s;
    this.fillSlider(r, s, o, a);
  }
  fillSlider(t, e, i, n) {
    this.toSlider.style.background = `linear-gradient(\n      to right,\n      ${this.sliderColor} 0%,\n      ${this.sliderColor} calc(${t}% + ${i}px),\n      ${this.rangeColor} calc(${t}% + ${i}px),\n      ${this.rangeColor} calc(${e}% + ${n}px),\n      ${this.sliderColor} calc(${e}% + ${n}px),\n      ${this.sliderColor} 100%)`;
  }
  handleResetButtonClick(t) {
    t.preventDefault(),
      t.stopPropagation(),
      (this.fromInput.value = null),
      (this.toInput.value = null),
      this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 })),
      this.toInput.dispatchEvent(new Event("input", { bubbles: !0 })),
      this.hideResetButton();
  }
  removeListeners() {
    this.fromSlider.removeEventListener("input", this.updateFromSlider.bind(this)),
      this.toSlider.removeEventListener("input", this.updateToSlider.bind(this)),
      this.fromInput.removeEventListener("input", this.updateFromInput.bind(this)),
      this.toInput.removeEventListener("input", this.updateToInput.bind(this)),
      this.resetButton.removeEventListener("click", this.handleResetButtonClick.bind(this));
  }
  hideResetButton() {
    this.resetButton.classList.add("hidden");
  }
  showResetButton() {
    this.resetButton.classList.remove("hidden");
  }
  disconnectedCallback() {
    this.removeListeners();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const minInput = this.inputs[0];
    const maxInput = this.inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', event => {
      event.preventDefault();
      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetFilters extends DropdownDisclosure {
  constructor() {
    super();

    this.container = this.querySelector('summary').nextElementSibling;
  }

  open(summaryElement, detailsElement) {
    if (
      window.innerWidth >= Number(this.container.dataset.breakpoint)
    ) {
      super.open(summaryElement, detailsElement);
      return;
    }

    bodyScroll.lock(
      this.container.querySelector('[data-facets-body]')
    );
    super.open(summaryElement, detailsElement);
  }

  close(event, summaryElement, detailsElement) {
    if (
      window.innerWidth >= Number(this.container.dataset.breakpoint)
    ) {
      super.close(event, summaryElement, detailsElement);
      return;
    }

    bodyScroll.unlock(
      this.container.querySelector('[data-facets-body]')
    );
    super.close(event, summaryElement, detailsElement);
  }
}

customElements.define('facet-filters', FacetFilters);
